import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { WebSocketService } from './web-socket.service';

@Injectable({
  providedIn: 'root',
})
export class NewViewService {
  // tslint:disable-next-line:variable-name
  private _newViewSubscription: Subscription;

  private $newView: BehaviorSubject<any> = new BehaviorSubject({});

  constructor(private wsService: WebSocketService) {
    this._newViewSubscription = this.wsService.listen('newView').subscribe((message) => {
      if (message == null) {
        return;
      }
      if (typeof message === 'string') {
        message = JSON.parse(message);
      }
      if (Array.isArray(message)) {
        message.forEach(processNewView);
      } else {
        processNewView(message);
      }
    });

    const processNewView = (newView) => {
      if (newView == null) {
        return;
      }
      const actualState = this.$newView.getValue();
      if (actualState[newView.lane] == null) {
        actualState[newView.lane] = newView;
      }
      actualState[newView.lane] = newView;
      this.$newView.next(actualState);
    };

    console.log('Estado del kiosko guardados en newViewService', this.$newView);
  }

  OnDestroy() {
    this._newViewSubscription.unsubscribe();
  }

  getCurrentNewView = (laneId: number) => {
    console.log('getCurrentNewView:  Solicitando estados actual de los kioskos...');
    this.wsService.send('getNewView', { laneId });
  };

  getKioskState(laneId) {
    return this.$newView.asObservable().pipe(
      map((kioskState) => kioskState[laneId]),
      distinctUntilChanged()
    );
  }
}
